import {APP} from './appActionTypes';

export function setSiteLoaded() {
  return {
    type: APP.LOADING,
    payload: false
  };
}
export function setModal(popupName) {
  return {
    type: APP.SET_MODAL,
    payload: popupName
  };
}
export function setModalData(data) {
  return {
    type: APP.SET_MODAL_DATA,
    payload: data
  };
}

export function closeModal() {
  return {
    type: APP.CLOSE_MODAL,
    payload: {
      modal: ''
    }
  };
}

export function setModalAdditional(popupName) {
  return {
    type: APP.SET_MODAL_ADDITIONAL,
    payload: popupName
  };
}
export function showConfirmPopup(data) {
  return {
    type: APP.SHOW_CONFIRM_POPUP,
    payload: data
  };
}
export function hideConfirmPopup() {
  return {
    type: APP.HIDE_CONFIRM_POPUP
  };
}

export function closeModalAdditional() {
  return {
    type: APP.CLOSE_MODAL_ADDITIONAL,
    payload: {
      modal: ''
    }
  };
}
